import * as React from 'react';
import type { SVGProps } from 'react';

const SvgCheckCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={21} height={21} {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      stroke="#ED403A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
    >
      <path d="M19.947 9.55v.871a9.474 9.474 0 1 1-5.618-8.659" />
      <path d="m19.947 2.842-9.473 9.483-2.842-2.842" />
    </g>
  </svg>
);
export default SvgCheckCircle;
